import "antd/es/dropdown/style";
import _Dropdown from "antd/es/dropdown";
import "antd/es/input/style";
import _Input from "antd/es/input";
import "antd/es/button/style";
import _Button from "antd/es/button";
import "antd/es/divider/style";
import _Divider from "antd/es/divider";
import "antd/es/space/style";
import _Space from "antd/es/space";
import "antd/es/menu/style";
import _Menu from "antd/es/menu";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import moment from 'moment';
import classname from 'classnames';
import invariant from 'invariant';
import { useState, useRef, useReducer, useContext, useEffect, useLayoutEffect } from 'react';
import { FilterOutlined, SearchOutlined, ArrowDownOutlined, CrossOutlined } from 'iglooicon';
import './style/index';
import { LocaleContext } from '../locale';
import RangePicker from './rangePicker';
import CreateCheckBoxFilter from './checkBox';
import CreteRadioBoxFilter from './radioBox';
import CustomizeFilter from './customize';
import Typography from '../typography';
import Select from '../select';
var defaultFormat = 'DD / MM / YYYY';

function handleFilterDisable() {
  var all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var disable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (disable.length === 0) {
    return all;
  }

  return all.filter(function (item) {
    return !disable.includes(item);
  });
}

function getDefaultOptions(params) {
  return params.reduce(function (res, item) {
    var key = item.key,
        defaultChoosed = item.default,
        _item$disabled = item.disabled,
        disabled = _item$disabled === void 0 ? [] : _item$disabled,
        type = item.type,
        disabledDate = item.disabledDate; // 判定一下默认时间在不在 不可选时间中

    if (type === 'date' && typeof disabledDate === 'function' && defaultChoosed && defaultChoosed.length) {
      // 判定的时候需要以 '天'作为最小单位
      var begin = moment(defaultChoosed[0]).endOf('day');
      var end = moment(defaultChoosed[1]).endOf('day');
      invariant(!disabledDate(begin) && !disabledDate(end), 'The default date is within a non-selectable time range');
    }

    if (type === 'single') {
      invariant(_typeof(defaultChoosed) !== 'object', 'The radio default value can not be a object');
      invariant(disabled.indexOf(defaultChoosed) === -1, 'The default value cannot be in the non-selectable range');
      return defaultChoosed ? _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, defaultChoosed)) : res;
    }

    return defaultChoosed ? _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, handleFilterDisable(defaultChoosed, disabled))) : res;
  }, {});
} // 在getDefaultOptions之后执行 就不用再判断 默认时间不合法的问题了


function getChoosedTags(params, choosed) {
  return params.reduce(function (res, item) {
    var key = item.key,
        type = item.type,
        _item$format = item.format,
        format = _item$format === void 0 ? defaultFormat : _item$format,
        options = item.options,
        _item$canNotDelete = item.canNotDelete,
        canNotDelete = _item$canNotDelete === void 0 ? false : _item$canNotDelete,
        filterItemTitle = item.filterItemTitle,
        tagTitle = item.tagTitle;
    var choosedOption = {
      label: '',
      key: '',
      type: '',
      optionValue: ''
    };

    if (choosed[key]) {
      switch (type) {
        case 'customize':
          invariant(typeof tagTitle === 'function', 'customize option must has a tagTitle function');
          choosedOption.label = tagTitle(choosed[key]);
          choosedOption.optionValue = choosed[key];
          choosedOption.key = key;
          choosedOption.type = type;
          res.push(choosedOption);
          break;

        case 'date':
          var beginTime = moment(choosed[key][0]).format(format);
          var endTime = moment(choosed[key][1]).format(format);
          choosedOption.label = "".concat(filterItemTitle, ":").concat(beginTime, "-").concat(endTime);
          choosedOption.key = key;
          choosedOption.type = type;
          choosedOption.optionValue = choosed[key];

          if (canNotDelete) {
            choosedOption.canNotDelete = canNotDelete;
          }

          res.push(choosedOption);
          break;

        case 'mult':
          options === null || options === void 0 ? void 0 : options.map(function (item) {
            var multChoosed = {
              label: '',
              key: '',
              type: '',
              optionValue: ''
            };
            var label = item.label,
                value = item.value;

            if (choosed[key].indexOf(value) !== -1) {
              multChoosed.key = key;
              multChoosed.label = label;
              multChoosed.type = type;
              multChoosed.optionValue = value;
              res.push(multChoosed);
            }
          });
          break;

        case 'single':
          options === null || options === void 0 ? void 0 : options.map(function (item) {
            var label = item.label,
                value = item.value;

            if (choosed[key] === value) {
              choosedOption.key = key;
              choosedOption.label = label;
              choosedOption.type = type;
              choosedOption.optionValue = value;

              if (canNotDelete) {
                choosedOption.canNotDelete = canNotDelete;
              }

              res.push(choosedOption);
            }
          });
          break;

        default:
          break;
      }
    }

    return res;
  }, []);
}

function optionsChange(state, action) {
  var type = action.type,
      value = action.value;

  switch (type) {
    case 'default':
      return value;

    case 'deleteOne':
      return value;

    case 'deleteAll':
      return value;

    default:
      break;
  }

  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, type, value));
}

function dataPickerOpenStatusReducer(state, action) {
  var type = action.type,
      value = action.value;
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, type, value));
}

function getCheckBoxSelectedAll(params) {
  return params.reduce(function (res, item) {
    var key = item.key,
        _item$options = item.options,
        options = _item$options === void 0 ? [] : _item$options,
        type = item.type;
    var allSelected = options.map(function (option) {
      return option.value;
    });
    return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, allSelected));
  }, {});
}

function getTimePickerOPtionsKey(params) {
  return params.filter(function (item) {
    return item.type === 'date';
  }).map(function (item) {
    return item.key;
  });
} // cbFucs :callBack functions


function deleteSomeOne(optionsConfirmed, optionItem, cbFucs) {
  var key = optionItem.key,
      type = optionItem.type,
      optionValue = optionItem.optionValue;

  switch (type) {
    case 'date':
      delete optionsConfirmed[key];
      break;

    case 'mult':
      // 通过useReducer之后的数据 和 optionsAllSelected[key] 存在引用关系处理一下
      optionsConfirmed[key] = optionsConfirmed[key].map(function (e) {
        return e;
      });
      var deletedIndex = optionsConfirmed[key].indexOf(optionValue);
      optionsConfirmed[key].splice(deletedIndex, 1);
      break;

    case 'single':
      delete optionsConfirmed[key];
      break;

    case 'customize':
      delete optionsConfirmed[key];
      break;
  }

  var cbArr = typeof cbFucs === 'function' ? [cbFucs] : cbFucs;
  cbArr.forEach(function (item) {
    item(optionsConfirmed);
  });
}

var getTextWidth = function getTextWidth(str) {
  if (typeof document === 'undefined') {
    return str.length * 12;
  }

  var ele = document.createElement('span');
  ele.style.fontSize = '12px';
  ele.style.opacity = '0';
  ele.innerText = str;
  document.body.appendChild(ele);
  var width = ele.offsetWidth;
  document.body.removeChild(ele);
  return width + 8 * 2 + 8 + 24;
}; // 将对象的数组属性排序， 这样通过JSON 字符串比较的时候才不会有顺序问题


function sortObjArr(obj) {
  var keys = Object.keys(obj);
  return keys.reduce(function (res, item) {
    var prop = obj[item];

    if (Array.isArray(prop)) {
      return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, item, prop.sort()));
    }

    return res;
  }, {});
} // 需要将日期的部分精确到天


function judgeChange(defaultOptions, newOptions, timePickerKey) {
  // 先将newOptions中的空数组去掉
  var newChoosedKeys = Object.keys(newOptions);
  newChoosedKeys.forEach(function (key) {
    if (Array.isArray(newOptions[key]) && newOptions[key].length === 0) {
      delete newOptions[key];
    }
  });

  if (Object.keys(defaultOptions).length !== Object.keys(newOptions).length) {
    return true;
  }

  if (timePickerKey.length === 0) {
    return JSON.stringify(sortObjArr(defaultOptions)) !== JSON.stringify(sortObjArr(newOptions));
  } // 不再引库了


  var JsonDefault = JSON.parse(JSON.stringify(defaultOptions));
  var JsonNew = JSON.parse(JSON.stringify(newOptions));
  timePickerKey.forEach(function (item) {
    if (JsonDefault[item]) {
      var beginTime = JsonDefault[item][0];
      var endTime = JsonDefault[item][1];
      var date = [moment(beginTime).format('YYYY-MM-DD'), moment(endTime).format('YYYY-MM-DD')];
      JsonDefault[item] = date;
    }

    if (JsonNew[item]) {
      var _beginTime = JsonNew[item][0];
      var _endTime = JsonNew[item][1];
      var _date = [moment(_beginTime).format('YYYY-MM-DD'), moment(_endTime).format('YYYY-MM-DD')];
      JsonNew[item] = _date;
    }
  });
  return JSON.stringify(sortObjArr(JsonDefault)) !== JSON.stringify(sortObjArr(JsonNew));
}

var FilterComponent = function FilterComponent(props) {
  var Option = Select.Option;

  var _useContext = useContext(LocaleContext),
      formatMessage = _useContext.formatMessage,
      currentLang = _useContext.currentLang;

  var showDefaultOptions = props.showDefaultOptions,
      _props$onFilter = props.onFilter,
      onFilter = _props$onFilter === void 0 ? function () {} : _props$onFilter,
      placeholder = props.placeholder,
      _props$parentFilterCa = props.parentFilterCallBack,
      parentFilterCallBack = _props$parentFilterCa === void 0 ? function () {} : _props$parentFilterCa,
      _props$deleteAllTagsT = props.deleteAllTagsType,
      deleteAllTagsType = _props$deleteAllTagsT === void 0 ? 'restFilters' : _props$deleteAllTagsT,
      _props$searchWithFilt = props.searchWithFilter,
      searchWithFilter = _props$searchWithFilt === void 0 ? false : _props$searchWithFilt,
      searchInputDefault = props.searchInputDefault,
      initValue = props.initValue,
      inputOnly = props.inputOnly,
      beforeOpenFilter = props.beforeOpenFilter,
      resetCallBack = props.resetCallBack;
  var filterTitle = props.filterTitle,
      _props$filterItems = props.filterItems,
      filterItems = _props$filterItems === void 0 ? [] : _props$filterItems; // id controller

  var showIdSelect = props.showIdSelect,
      _props$idKeyTypes = props.idKeyTypes,
      idKeyTypes = _props$idKeyTypes === void 0 ? [] : _props$idKeyTypes,
      idKeyTypeDefault = props.idKeyTypeDefault;

  var _useState = useState(idKeyTypeDefault),
      _useState2 = _slicedToArray(_useState, 2),
      idName = _useState2[0],
      setIdName = _useState2[1];

  invariant(!showIdSelect || idKeyTypes.length !== 0, 'must set idKeyTypes while showIdSelect is true');
  invariant(typeof onFilter === 'function', 'filterCallBack must be a function'); // option controller

  var dropDownContainerRef = useRef(); // 处理antd日期组件选择完还有高亮问题

  var invisibleRef = useRef(); // 控制 展开框的关闭

  var openStatusTagRef = useRef(undefined); // 需要做高度动态效果，需要获取一下内容的高度

  var heightRef = useRef(undefined);

  var _useState3 = useState(48),
      _useState4 = _slicedToArray(_useState3, 2),
      openTagsHeight = _useState4[0],
      setOpenTagHeight = _useState4[1]; // 用来控制 search input的高亮和 切换


  var searchInput = useRef(null); //inner options controller

  var _useState5 = useState(function () {
    return getDefaultOptions(filterItems);
  }),
      _useState6 = _slicedToArray(_useState5, 1),
      defaultOptions = _useState6[0];

  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      optionsAllSelected = _useState8[0],
      setOptionsAllSelected = _useState8[1];

  var _useReducer = useReducer(optionsChange, initValue ? _objectSpread({}, initValue) : _objectSpread({}, defaultOptions)),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      optionsChanged = _useReducer2[0],
      dispatchOptionsChange = _useReducer2[1];

  var _useState9 = useState(initValue ? _objectSpread({}, initValue) : _objectSpread({}, defaultOptions)),
      _useState10 = _slicedToArray(_useState9, 2),
      confirmed = _useState10[0],
      setConfimed = _useState10[1]; //dropDown visible


  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      dropVisible = _useState12[0],
      setDropVisible = _useState12[1]; //filter button high light


  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      hightLightFilterButton = _useState14[0],
      setHighLightFilter = _useState14[1]; // type-> 0:custom  1:last day    2:last 7 Days     3:last month    4:this month


  var _useState15 = useState(-1),
      _useState16 = _slicedToArray(_useState15, 2),
      timeRangeType = _useState16[0],
      setTimeRangeType = _useState16[1];

  var _useState17 = useState(-1),
      _useState18 = _slicedToArray(_useState17, 2),
      confirmedTimeRange = _useState18[0],
      setConfirmTimeRange = _useState18[1]; //对时间比较的时候需要只精确到 “天”，预先拿到那些key是代表日期的


  var _useState19 = useState(getTimePickerOPtionsKey(filterItems)),
      _useState20 = _slicedToArray(_useState19, 1),
      timePickerKey = _useState20[0];

  var _useReducer3 = useReducer(dataPickerOpenStatusReducer, timePickerKey.reduce(function (res, key) {
    res[key] = false;
    return res;
  }, {})),
      _useReducer4 = _slicedToArray(_useReducer3, 2),
      dataPickerOpenStatus = _useReducer4[0],
      setPickerOpenStatus = _useReducer4[1]; // 对于已选择部分在 ‘input’ 上的展开控制


  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      inputExtend = _useState22[0],
      extendInputContent = _useState22[1];

  var _useState23 = useState([]),
      _useState24 = _slicedToArray(_useState23, 2),
      maxTagsWhenClosed = _useState24[0],
      setMaxTagsWhenClosed = _useState24[1];

  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      oneLineCanShow = _useState26[0],
      setOneLineCanShow = _useState26[1]; // 不管是默认还是 之后手动选择的 filter的名字


  var _useState27 = useState(function () {
    return getChoosedTags(filterItems, defaultOptions);
  }),
      _useState28 = _slicedToArray(_useState27, 2),
      choosedTags = _useState28[0],
      setChoosedTags = _useState28[1]; // 如果没有filter选项 需要展示出input框


  var _useState29 = useState(false),
      _useState30 = _slicedToArray(_useState29, 2),
      noFilters = _useState30[0],
      setNoFilters = _useState30[1]; // 这个状态标志着 此时只有不能删除的 filters（根据业务来的）


  var _useState31 = useState(false),
      _useState32 = _slicedToArray(_useState31, 2),
      onlyHaveCanNotDeleteTags = _useState32[0],
      setOnlyHaveCanNotDeleteTags = _useState32[1]; // 在onlyOneTagAndCanNotDelete状态下 开启input 输入框 进行search 搜索


  var _useState33 = useState(false),
      _useState34 = _slicedToArray(_useState33, 2),
      showSearchInputWhenHasTag = _useState34[0],
      setShowSearchInputWhenHasTag = _useState34[1]; // 删除tags的过程中 需要一直展示tags Input


  var _useState35 = useState(false),
      _useState36 = _slicedToArray(_useState35, 2),
      stillHaveTagsToDelete = _useState36[0],
      setStillHaveTagsToDelete = _useState36[1];

  var _useState37 = useState(),
      _useState38 = _slicedToArray(_useState37, 2),
      searchInputValue = _useState38[0],
      setSearchInputValue = _useState38[1];

  var _useState39 = useState(searchInputDefault !== undefined ? true : false),
      _useState40 = _slicedToArray(_useState39, 2),
      showSearchInputDefault = _useState40[0],
      setShowSearchInputDefault = _useState40[1]; // 处理options 中 data?.map data 初始化为[] 没有数据的情况


  useEffect(function () {
    setOptionsAllSelected(getCheckBoxSelectedAll(filterItems));
  }, [JSON.stringify(filterItems)]); // 设置tag框 高度改变动效

  useLayoutEffect(function () {
    var timer = setTimeout(function () {
      var _heightRef$current;

      setOpenTagHeight((_heightRef$current = heightRef.current) === null || _heightRef$current === void 0 ? void 0 : _heightRef$current.offsetHeight);
    }, 0);
    return function () {
      return clearTimeout(timer);
    };
  }, [inputExtend, JSON.stringify(confirmed)]); // 针对删除了所有可删除的filter tags情况，自动聚焦到seatch Input

  useLayoutEffect(function () {
    if (noFilters || showSearchInputWhenHasTag) {
      searchInput.current.focus();
    }
  }, [noFilters, showSearchInputWhenHasTag]); // filter 改变之后更新选中的tags

  useEffect(function () {
    if (hightLightFilterButton || showDefaultOptions || stillHaveTagsToDelete || initValue) {
      // 判定filter高亮
      if (judgeChange(defaultOptions, confirmed, timePickerKey)) {
        setHighLightFilter(true);
      } else {
        setHighLightFilter(false);
      }

      var tags = getChoosedTags(filterItems, confirmed);
      setChoosedTags(tags); // 选择的filter 数量控制 input和tags 框谁展示

      if (tags.length === 0) {
        setNoFilters(true);
        extendInputContent(false);
        return;
      } else {
        setNoFilters(false);
        setShowSearchInputWhenHasTag(false);
      }

      if (tags.every(function (tag) {
        return tag.canNotDelete === true;
      })) {
        setOnlyHaveCanNotDeleteTags(true);
      } else {
        setOnlyHaveCanNotDeleteTags(false);
      }

      var tagsWidth = tags.map(function (item) {
        return getTextWidth(item.label);
      });
      var maxTagContentWidth = showIdSelect ? 388 : 488; // 减去的是函数中算padding多加的

      var ellipsisWidth = getTextWidth('...') - (8 * 2 + 8 + 24);
      var canShowTags = []; // -12:reduce函数中多加了一个12

      var currentWidth = -12;
      var tagsOnelineWidth = tagsWidth.reduce(function (res, item) {
        // 12是每一个 tag之前的margin值
        return res += item + 12;
      }, currentWidth);

      if (tagsOnelineWidth <= maxTagContentWidth) {
        setMaxTagsWhenClosed(tags);
        setOneLineCanShow(true);
        return;
      }

      currentWidth = ellipsisWidth;
      setOneLineCanShow(false);

      for (var i = 0; i < tags.length; i++) {
        if (maxTagContentWidth >= currentWidth + tagsWidth[i]) {
          currentWidth += tagsWidth[i] + 12;
          canShowTags.push(tags[i]);
        }
      }

      setMaxTagsWhenClosed(canShowTags);
    }
  }, [hightLightFilterButton, showDefaultOptions, JSON.stringify(confirmed), currentLang]); // 用于关闭开启的 tag框

  useEffect(function () {
    if (!inputExtend) return;

    function closeTagContent(e) {
      if (!openStatusTagRef.current) return;

      if (!openStatusTagRef.current.contains(e.target)) {
        extendInputContent(false);
      }
    }

    window.addEventListener('click', closeTagContent);
    return function () {
      window.removeEventListener('click', closeTagContent);
    };
  }, [inputExtend]);

  var menu = _jsx(_Menu, {
    children: _jsxs(_Menu.Item, {
      children: [_jsxs("div", {
        className: "igloo-form-filter-drop-down-container-content",
        children: [_jsxs(_Space, {
          children: [_jsx(FilterOutlined, {
            style: {
              fontSize: '24px',
              color: '#666666'
            }
          }), _jsx(Typography, {
            level: "h4",
            children: filterTitle
          })]
        }), _jsx(_Divider, {
          style: {
            margin: '16px 0px'
          }
        }), filterItems.map(function (item) {
          var type = item.type,
              options = item.options,
              filterItemTitle = item.filterItemTitle,
              key = item.key,
              disabled = item.disabled,
              disabledDate = item.disabledDate,
              _item$format2 = item.format,
              format = _item$format2 === void 0 ? defaultFormat : _item$format2,
              dateRangeConfig = item.dateRangeConfig,
              render = item.render,
              tagTitle = item.tagTitle,
              onChangeProps = item.onChange;

          switch (type) {
            case 'customize':
              invariant(typeof render === 'function', 'render is required of customize filter option');
              invariant(typeof tagTitle === 'function', 'tagTitle is required of customize filter option');

              var onChange = function onChange(value) {
                return dispatchOptionsChange({
                  type: key,
                  value: value
                });
              };

              return _jsx(CustomizeFilter, {
                optionKey: key,
                value: optionsChanged[key],
                onChange: onChange,
                render: render
              }, key);

            case 'date':
              return _jsx(RangePicker, {
                title: filterItemTitle || formatMessage({
                  id: 'Date'
                }),
                optionKey: key,
                format: format,
                choosed: optionsChanged[key],
                disabledDate: disabledDate,
                valueConfirm: dispatchOptionsChange,
                setRangeType: setTimeRangeType,
                tiemRange: timeRangeType,
                onFocus: invisibleRef.current,
                dateRangeConfig: dateRangeConfig,
                pickerOpenStatus: dataPickerOpenStatus[key],
                setPickerOpenStatus: setPickerOpenStatus,
                onChange: onChangeProps
              }, key);

            case 'mult':
              invariant(Array.isArray(options), 'options is required');
              return _jsx(CreateCheckBoxFilter, {
                title: filterItemTitle,
                configList: options,
                optionKey: key,
                allSelected: optionsAllSelected[key],
                chooseed: optionsChanged[key],
                disabled: disabled,
                handleOptionsChange: dispatchOptionsChange,
                setConfirmValue: setConfimed,
                onChange: onChangeProps
              }, key);

            case 'single':
              invariant(Array.isArray(options), 'options is required');
              return _jsx(CreteRadioBoxFilter, {
                title: filterItemTitle,
                configList: options,
                optionKey: key,
                chooseed: optionsChanged[key],
                disabled: disabled,
                handleOptionsChange: dispatchOptionsChange,
                setConfirmValue: setConfimed,
                onChange: onChangeProps
              }, key);
          }
        })]
      }), _jsxs("div", {
        className: "igloo-form-filter-drop-down-footer",
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        children: [_jsx("span", {
          onClick: function onClick() {
            typeof resetCallBack === 'function' && resetCallBack(_objectSpread({}, defaultOptions));
            setTimeout(function () {
              setTimeRangeType(-1);
              dispatchOptionsChange({
                type: 'default',
                value: _objectSpread({}, defaultOptions)
              });
            }, 10);
          },
          children: _jsx(Typography, {
            level: "h4",
            children: formatMessage({
              id: 'Reset All Filters'
            })
          })
        }), _jsxs(_Space, {
          size: 16,
          children: [_jsx("span", {
            onClick: function onClick() {
              setDropVisible(false);
              dispatchOptionsChange({
                type: 'default',
                value: confirmed
              });
              setTimeRangeType(confirmedTimeRange);
            },
            children: _jsx(Typography, {
              level: "h4",
              children: formatMessage({
                id: 'Cancel'
              })
            })
          }), _jsx(_Button, {
            onClick: function onClick() {
              setDropVisible(false);
              setShowSearchInputDefault(false);
              setConfimed(optionsChanged);
              setConfirmTimeRange(timeRangeType);
              setSearchInputValue('');

              if (typeof onFilter === 'function') {
                onFilter(_objectSpread({}, optionsChanged));
                typeof parentFilterCallBack === 'function' && parentFilterCallBack(_objectSpread({}, optionsChanged));
              }

              if (judgeChange(defaultOptions, optionsChanged, timePickerKey)) {
                setHighLightFilter(true);
              } else {
                setHighLightFilter(false);
              }
            },
            children: _jsx(Typography, {
              level: "h4",
              style: {
                padding: '0px 35px'
              },
              children: formatMessage({
                id: 'Apply'
              })
            })
          })]
        })]
      })]
    }, 1)
  });

  return _jsxs("div", {
    className: "".concat(showIdSelect ? 'igloo-form-filter-with-select' : 'igloo-form-filter'),
    children: [_jsx(_Input, {
      ref: invisibleRef,
      style: {
        width: '0',
        height: '0',
        padding: '0px',
        border: '0px'
      }
    }), showIdSelect && idKeyTypes.length !== 0 && _jsx(Select, {
      className: "igloo-form-filter-id-select",
      onChange: function onChange(e) {
        return setIdName(String(e));
      },
      defaultValue: idKeyTypeDefault,
      suffixIcon: _jsx(ArrowDownOutlined, {
        style: {
          fontSize: 24
        }
      }),
      children: idKeyTypes.map(function (item) {
        return _jsx(Option, {
          value: item.value,
          children: _jsx(Typography, {
            level: "body1",
            children: item.label
          })
        }, item.value);
      })
    }), (hightLightFilterButton || showDefaultOptions || stillHaveTagsToDelete) && !noFilters && !showSearchInputDefault && !showSearchInputWhenHasTag ? _jsxs("div", {
      className: "igloo-filter-tag-position-reference",
      children: [_jsxs("div", {
        ref: heightRef,
        className: classname({
          'tag-defalut-container-hide-status': inputExtend,
          'igloo-form-filter-has-select-tag-container': showIdSelect,
          'igloo-form-filter-default-tag-container': !showIdSelect
        }),
        onClick: function onClick(e) {
          e.stopPropagation();
          !oneLineCanShow && extendInputContent(true);

          if (onlyHaveCanNotDeleteTags) {
            setShowSearchInputWhenHasTag(true);
          }
        },
        children: [_jsx(SearchOutlined, {
          className: 'search-icon'
        }), _jsxs(_Space, {
          size: [12, 8],
          className: "tag-container",
          style: {
            flex: '1'
          },
          children: [_toConsumableArray(inputExtend ? choosedTags : maxTagsWhenClosed).map(function (item, index) {
            return _jsxs("div", {
              className: "tag-card",
              children: [_jsx(Typography, {
                level: "body3",
                children: item.label
              }), !item.canNotDelete && _jsx(CrossOutlined, {
                className: "delete-icon",
                onClick: function onClick(e) {
                  e.stopPropagation();
                  var type = item.type;

                  if (type === 'date') {
                    setTimeRangeType(-1);
                  }

                  var statusCallBack = function statusCallBack(options) {
                    dispatchOptionsChange({
                      type: 'deleteOne',
                      value: options
                    });
                    setConfimed(options);
                    var tags = getChoosedTags(filterItems, options); // 删除过程中需要一直展示tags 不切换到 search input

                    if (tags.length) {
                      setStillHaveTagsToDelete(true);
                    } else {
                      setStillHaveTagsToDelete(false);
                    }
                  };

                  var handleFilter = function handleFilter(confirmed) {
                    typeof onFilter === 'function' && onFilter(_objectSpread({}, confirmed));
                    typeof parentFilterCallBack === 'function' && parentFilterCallBack(_objectSpread({}, confirmed));
                  };

                  deleteSomeOne(confirmed, item, [statusCallBack, handleFilter]);
                }
              })]
            }, index);
          }), !oneLineCanShow && !inputExtend && _jsx("span", {
            children: "..."
          })]
        }), !onlyHaveCanNotDeleteTags && _jsx(CrossOutlined, {
          className: "delete-all-icon",
          onClick: function onClick(e) {
            e.stopPropagation();
            setTimeRangeType(-1);
            extendInputContent(false); // 不管什么情况下的 删除全部 都不应该继续展示tags

            setStillHaveTagsToDelete(false); // 对于全部删除而言 只能使用 choosedTags

            var deleteAll = choosedTags.reduce(function (res, item) {
              var key = item.key,
                  optionValue = item.optionValue,
                  canNotDelete = item.canNotDelete;
              return canNotDelete ? _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, optionValue)) : res;
            }, {});
            var afterDeleteValue = deleteAllTagsType === 'restFilters' ? _objectSpread({}, defaultOptions) : deleteAll;
            dispatchOptionsChange({
              type: 'deleteAll',
              value: afterDeleteValue
            });
            setConfimed(afterDeleteValue);

            if (typeof onFilter === 'function') {
              onFilter(_objectSpread({}, afterDeleteValue));
              typeof parentFilterCallBack === 'function' && parentFilterCallBack(_objectSpread({}, afterDeleteValue));
            }
          }
        })]
      }), _jsxs("div", {
        ref: openStatusTagRef,
        className: classname('tag-extend-container-hide-status', {
          'igloo-form-filter-has-select-tag-container': showIdSelect,
          'igloo-form-filter-default-tag-container': !showIdSelect,
          'tag-extend-container-show-status': inputExtend
        }),
        style: {
          height: openTagsHeight
        },
        onClick: function onClick(e) {
          e.stopPropagation();

          if (onlyHaveCanNotDeleteTags) {
            setShowSearchInputWhenHasTag(true);
          }
        },
        children: [_jsx(SearchOutlined, {
          className: 'search-icon'
        }), _jsx(_Space, {
          size: [12, 8],
          className: "tag-container",
          style: {
            flex: '1'
          },
          children: _toConsumableArray(inputExtend ? choosedTags : maxTagsWhenClosed).map(function (item, index) {
            return _jsxs("div", {
              className: "tag-card",
              children: [_jsx(Typography, {
                level: "body3",
                children: item.label
              }), !item.canNotDelete && _jsx(CrossOutlined, {
                className: "delete-icon",
                onClick: function onClick(e) {
                  e.stopPropagation();
                  var type = item.type;

                  if (type === 'date') {
                    setTimeRangeType(-1);
                  }

                  var statusCallBack = function statusCallBack(options) {
                    dispatchOptionsChange({
                      type: 'deleteOne',
                      value: options
                    });
                    setConfimed(options);
                    var tags = getChoosedTags(filterItems, options); // 删除过程中需要一直展示tags 不切换到 search input

                    if (tags.length) {
                      setStillHaveTagsToDelete(true);
                    } else {
                      setStillHaveTagsToDelete(false);
                    }
                  };

                  var handleFilter = function handleFilter(confirmed) {
                    typeof onFilter === 'function' && onFilter(_objectSpread({}, confirmed));
                    typeof parentFilterCallBack === 'function' && parentFilterCallBack(_objectSpread({}, confirmed));
                  };

                  deleteSomeOne(confirmed, item, [statusCallBack, handleFilter]);
                }
              })]
            }, index);
          })
        }), !onlyHaveCanNotDeleteTags && _jsx(CrossOutlined, {
          className: "delete-all-icon",
          onClick: function onClick() {
            setTimeRangeType(-1);
            extendInputContent(false); // 不管什么情况下的 删除全部 都不应该继续展示tags

            setStillHaveTagsToDelete(false); // 对于全部删除而言 只能使用 choosedTags

            var deleteAll = choosedTags.reduce(function (res, item) {
              var key = item.key,
                  optionValue = item.optionValue,
                  canNotDelete = item.canNotDelete;
              return canNotDelete ? _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, optionValue)) : res;
            }, {});
            var afterDeleteValue = deleteAllTagsType === 'restFilters' ? _objectSpread({}, defaultOptions) : deleteAll;
            dispatchOptionsChange({
              type: 'deleteAll',
              value: afterDeleteValue
            });
            setConfimed(afterDeleteValue);

            if (typeof onFilter === 'function') {
              onFilter(_objectSpread({}, afterDeleteValue));
              typeof parentFilterCallBack === 'function' && parentFilterCallBack(_objectSpread({}, afterDeleteValue));
            }
          }
        })]
      })]
    }) : _jsx(_Input, {
      ref: searchInput,
      value: searchInputValue,
      onChange: function onChange(e) {
        return setSearchInputValue(e.target.value);
      },
      defaultValue: showSearchInputDefault ? searchInputDefault : undefined,
      placeholder: placeholder || '',
      onBlur: function onBlur() {
        if (showSearchInputWhenHasTag) {
          setShowSearchInputWhenHasTag(false);
        }
      },
      prefix: _jsx(SearchOutlined, {
        style: {
          fontSize: '24px',
          color: '#999999',
          marginRight: '12px'
        }
      }),
      className: "".concat(showIdSelect ? 'igloo-form-filter-has-select-input' : 'igloo-form-filter-default-input'),
      onPressEnter: function onPressEnter(e) {
        var value = undefined;

        if (e.target.value) {
          var _ref;

          value = searchWithFilter ? _objectSpread(_objectSpread(_defineProperty({}, idName || 'id', e.target.value), confirmed), {}, {
            searchValue: e.target.value,
            searchKey: idName
          }) : (_ref = {}, _defineProperty(_ref, idName || 'id', e.target.value), _defineProperty(_ref, "searchValue", e.target.value), _defineProperty(_ref, "searchKey", idName), _ref);
        } else {
          value = _objectSpread(_objectSpread({}, confirmed), {}, {
            searchValue: e.target.value,
            searchKey: idName
          });
        }

        onFilter(value);
        typeof parentFilterCallBack === 'function' && parentFilterCallBack(value);
      }
    }), !inputOnly && _jsx(_Dropdown, {
      getPopupContainer: function getPopupContainer() {
        return dropDownContainerRef.current;
      },
      overlay: dropVisible ? menu : _jsx(_Menu, {
        style: {
          display: 'none'
        }
      }),
      placement: 'bottomLeft',
      overlayClassName: "igloo-form-filter-drop-down-container",
      visible: dropVisible,
      onVisibleChange: function onVisibleChange(visible) {
        setDropVisible(visible);

        if (visible) {
          typeof beforeOpenFilter === 'function' && beforeOpenFilter(_objectSpread({}, confirmed));
        }

        setTimeout(function () {
          if (dropVisible) {
            setTimeRangeType(confirmedTimeRange);
            dispatchOptionsChange({
              type: 'default',
              value: _objectSpread({}, confirmed)
            });
          }
        }, 0);
      },
      trigger: ['click'],
      children: _jsx("div", {
        className: "igloo-form-filter-button-container",
        children: _jsx(_Button, {
          className: classname('igloo-form-filter-filter-button', {
            'igloo-form-filter-filter-button-active': dropVisible,
            'igloo-form-filter-filter-button-high-light': hightLightFilterButton
          }),
          icon: _jsx(FilterOutlined, {
            style: {
              fontSize: '24px'
            }
          }),
          onClick: function onClick() {
            setDropVisible(true);
          },
          children: _jsx("span", {
            className: "filter-text",
            children: _jsx(Typography, {
              level: "body1",
              children: formatMessage({
                id: 'Filter'
              })
            })
          })
        })
      })
    }), _jsx("div", {
      className: "igloo-form-filter-drop-down",
      ref: dropDownContainerRef
    })]
  });
};

export default FilterComponent;